import url from './url';



export default url(() => '/presets/create');
